import React from 'react';
import { Col, Row } from 'components/graylog';

import SupportSources from './SupportSources';

const ContactUs = () => (
  <Row className="content">
    <Col md={12}>
      <SupportSources />
    </Col>
  </Row>
);

export default ContactUs;
